import React, { FC } from 'react';

export const EmptyData: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="201"
      height="200"
      viewBox="0 0 201 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M134.7 163.76H66.58C50.3 163.76 37.02 150.48 37.02 134.12V65.8802C37.02 49.5602 50.3 36.2402 66.58 36.2402H134.66C150.94 36.2402 164.22 49.5202 164.22 65.8802V134.12C164.26 150.48 150.98 163.76 134.7 163.76Z"
        fill="#EFF2F4"
      />
      <path
        d="M126.46 115.8L155.78 155.24C158.54 158.96 157.74 164.2 153.98 166.92L152.82 167.76C149.06 170.48 143.78 169.6 141.14 165.76L112.9 125.4"
        fill="#F7C6CC"
      />
      <path
        d="M119.34 134.519C119.34 134.519 127.94 130.959 133.02 124.599L129.1 119.359L115.58 129.199L119.34 134.519Z"
        fill="#ED9FAC"
      />
      <path
        d="M100.38 129.76C122.207 129.76 139.9 112.066 139.9 90.2397C139.9 68.4134 122.207 50.7197 100.38 50.7197C78.5541 50.7197 60.8604 68.4134 60.8604 90.2397C60.8604 112.066 78.5541 129.76 100.38 129.76Z"
        fill="#EFF2F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.38 54.5218C80.6535 54.5218 64.6619 70.5133 64.6619 90.2399C64.6619 109.966 80.6534 125.958 100.38 125.958C120.107 125.958 136.098 109.966 136.098 90.2399C136.098 70.5133 120.107 54.5218 100.38 54.5218ZM57.0581 90.2399C57.0581 66.3138 76.454 46.918 100.38 46.918C124.306 46.918 143.702 66.3138 143.702 90.2399C143.702 114.166 124.306 133.562 100.38 133.562C76.454 133.562 57.0581 114.166 57.0581 90.2399Z"
        fill="#F7C6CC"
      />
      <path
        d="M100.1 113.04C102.486 113.04 104.42 111.106 104.42 108.72C104.42 106.335 102.486 104.4 100.1 104.4C97.7144 104.4 95.7803 106.335 95.7803 108.72C95.7803 111.106 97.7144 113.04 100.1 113.04Z"
        fill="#FF2B85"
      />
      <path
        d="M108.58 90.6004C109.78 89.8004 111.26 88.6004 112.58 87.0004C116.46 82.2804 115.82 77.8404 114.3 74.7204C112.66 71.2804 107.3 67.8404 100.14 68.3204C90.0598 69.0404 86.3398 76.5204 86.4598 80.8404C86.4998 82.7604 87.8998 84.3204 89.8198 84.4404C91.7398 84.5604 93.6598 83.3604 93.7798 81.4404C93.7798 81.2004 94.5798 75.8404 100.62 75.3204C104.26 75.0004 106.54 76.4804 107.22 77.8004C107.22 77.8004 108.66 80.4404 106.78 82.7204C105.94 83.7204 105.22 84.3204 104.22 85.0804L101.54 87.3204C95.8998 93.0804 96.8998 98.7604 96.8998 98.7604C97.0598 100.72 98.4598 102.28 100.42 102.28C102.38 102.28 103.9 100.72 103.9 98.7604V97.6404C104.06 96.1604 104.3 94.5204 105.86 92.8004C105.9 92.8804 107.78 91.1604 108.58 90.6004Z"
        fill="#FF2B85"
      />
    </svg>
  );
};
